module.exports = "/assets/data/bf163c34e57260919aca12384d9a1e31-WA12.data.json";